<template>
    <v-dialog v-model="showDialog" width="1200">
        <v-card tile height="800">
            <v-toolbar flat class="bg-gradient" height="64">
                <div style="display:flex; width:100%; height:64px; align-items:center;">
                    <v-btn x-large depressed color="transparent" style="position:absolute;" class="ml-2" dark @click.native="$emit('cancel')" ><v-icon small class="mr-2">$prev</v-icon> {{ $t("back") }}</v-btn>
                    <v-toolbar-title class="d-flex align-center justify-center toolbarTitle">{{ name }}</v-toolbar-title>
                </div> 
            </v-toolbar>

            <v-card-text class="pa-8" style="height: calc(100% - 64px);">
                <iframe :src="url" width="100%" height="100%" frameborder="0"></iframe>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "iFrameDialogComponent",
    props: ["showDialog", "name", "url"],
    data() {
        return {
        };
    },
    methods: {},
};
</script>

<style lang="scss">
</style>
